import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-profile-module',
    templateUrl: './profile-module.component.html',
    styleUrls: ['./profile-module.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProfileModuleComponent {
  constructor() {}
  @Input() group: FormGroup;
}
